const faFolder = {
  prefix: 'fal',
  iconName: 'folder',
  icon: [
    512,
    512,
    [128193, 128447, 61716, 'folder-blank'],
    'f07b',
    'M64 416l384 0c17.7 0 32-14.3 32-32l0-240c0-17.7-14.3-32-32-32l-149.3 0c-13.8 0-27.3-4.5-38.4-12.8L221.9 70.4c-5.5-4.2-12.3-6.4-19.2-6.4L64 64C46.3 64 32 78.3 32 96l0 288c0 17.7 14.3 32 32 32zm384 32L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64z',
  ],
};
export default faFolder;
